__turbopack_context__.v({
  "btn": "style-module-scss-module__nwEmXW__btn",
  "btns": "style-module-scss-module__nwEmXW__btns",
});
